/**  Manages a responsive tab UI */
class TabsComponent {
    /**  Initialises the tabs component */
    init() {
        var tabs = $(".tabs ul.nav-tabs");

        tabs.each(function (index, nativeElement) {
            var tabList = $(nativeElement);
            var activeLink = tabList.find("a.active");

            var scrollLeft = $(tabList).scrollLeft();
            var elementLeft = activeLink.offset().left - 100;

            if (elementLeft > scrollLeft) {
                tabList.scrollLeft(elementLeft);
            }
        });

    }
}

$(function () {
    let tabs = new TabsComponent();
    tabs.init();
});